const date = new Date()

const even = date % 2 === 0
const thirds = date % 3 === 0

export {
    even,
    thirds
}